import React from "react";
import {
  Grid,
  CrossCountryLogo,
  Column,
  Headline,
  SubHeadline,
  Paragraph,
  Link,
} from "cross-country";

/*
const Link = ({ url, text }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener, noreferrer"
    style={{ pointerEvents: "all", fontSize: "0.8em" }}
  >
    {text}
  </a>
);*/

export default function CrossCountryGrid() {
  return (
    <Grid>
      <Column
        hasChildrenCentered={false}
        customStyle={{ maxWidth: 500, margin: 10, padding: 10 }}
      >
        <Headline text="Cross Country Grid" />
        <Paragraph text="hello world" />
        <SubHeadline text="Links" size="small" />
        <Link text="caniuse" url="https://caniuse.com/#search=cssgrid/" />
        <Link text="Grid By Example" url="https://gridbyexample.com/" />
        <Link
          text="Editorial Design Patterns With CSS Grid And Named Columns"
          url="https://www.smashingmagazine.com/2019/10/editorial-design-patterns-css-grid-subgrid-naming/"
        />
        <Link
          text="Create your own design system"
          url="https://medium.com/codyhouse/create-your-design-system-part-2-grid-layout-aa961d59b8d6/"
        />
        <Column customStyle={{ width: "100%" }}>
          <a href="https://cross-country.now.sh/">
            <CrossCountryLogo width={"25"} />
          </a>
        </Column>
      </Column>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/components/gardens/cross-country-grid/CrossCountryGrid.js